<app-personalized-dialog [loading]="loading">
  <div dialog-title>
    @if (isEditing) {
      <span>Edit Collection</span>
    } @else {
      <span>Collection Information</span>
    }
  </div>
  <div dialog-content>
    
    @if (oilCollection?.client?._id || oilCollection?.client_ident_GUI) {
      <app-cliente-information-card
        [clientID]="oilCollection?.client?._id || oilCollection?.client_ident_GUI"
        size="small"
        class="block mb-3">
      </app-cliente-information-card>
    }

    <!-- ── Section 1: Collection Details ── -->
    <div class="kite-section-card mb-3">
      <div class="kite-section-title">
        <span>Collection Details</span>
      </div>
      <div class="row g-2">
        <app-read-only-field
          label="Driver"
          class="col-md-4 col-sm-12"
          [value]="oilCollection?.driver?.name || oilCollection?.driver || '—'">
        </app-read-only-field>
        
        @if (!isEditing) {
          <app-read-only-field
            label="Gross Oil Volume"
            class="col-md-4 col-sm-6"
            [value]="oilCollection?.gallons || '—'">
          </app-read-only-field>
          <app-read-only-field
            label="Collection Date & Time"
            class="col-md-4 col-sm-6"
            [value]="(oilCollection?.created_at | date:'MM/dd/yyyy hh:mm a':'America/New_York') || '—'">
          </app-read-only-field>
        } @else {
          <div class="col-md-4 col-sm-6">
            <label for="oilEditGallons" class="label">Gross oil volume</label>
            <input id="oilEditGallons" type="number" class="form-control" [(ngModel)]="editGallons">
          </div>
          <div class="col-md-4 col-sm-6">
            <label for="oilEditDate" class="label">Collection date</label>
            <input id="oilEditDate" type="date" class="form-control" [(ngModel)]="editDate">
          </div>
        }
      </div>
    </div>

    <!-- ── Section 2: Observations & Notes ── -->
    <div class="kite-section-card mb-0">
      <div class="kite-section-title">
        <span>Observations & Notes</span>
      </div>
      <div class="row g-2">
        @if (!isEditing) {
          @if (oilCollection?.observations?.manual_notes || oilCollection?.notes) {
            <app-read-only-field
              label="Notes"
              class="col-12"
              [value]="(oilCollection?.observations?.manual_notes || oilCollection?.notes) | titlecase">
            </app-read-only-field>
          }
        } @else {
          <div class="col-12">
            <label for="oilEditNotes" class="label">Notes</label>
            <textarea id="oilEditNotes" class="form-control" [(ngModel)]="editNotes" rows="3"></textarea>
          </div>
        }

        @if (oilCollection?.observations?.topic_ids?.length) {
          <div class="col-12 mt-1">
            <div class="observations-section">
              <span class="observations-label">Observations</span>
              <div class="badge-container">
                @for (topic of oilCollection.observations.topic_ids; track topic) {
                  <span class="observation-badge d-inline-flex align-items-center">
                    <i class="mdi mdi-tag-outline mr-1"></i>
                    {{ formatObservation(topic) | titlecase }}
                  </span>
                }
              </div>
            </div>
          </div>
        }

        @if (!isEditing && !oilCollection?.observations?.manual_notes && !oilCollection?.notes && !oilCollection?.observations?.topic_ids?.length) {
          <div class="col-12 text-muted small py-1">
            No observations or notes recorded for this collection.
          </div>
        }
      </div>
    </div>

  </div>
  <div dialog-actions class="d-flex w-100 justify-content-between">
    @if (!isEditing) {
      <app-button *appHasPermission="['oilRecovery', 'edit']" type="button" variant="blue-text" (onClick)="startEdit()">
        <i class="fa fa-edit mr-1"></i> Edit Collection
      </app-button>
      <app-button type="button" variant="secondary" aria-label="Close" (onClick)="activeModal.dismiss('close')">Close</app-button>
    } @else {
      <div></div>
      <div class="d-flex gap-2">
        <app-button type="button" variant="primary" (onClick)="save()">Update Collection</app-button>
        <app-button type="button" variant="secondary" (onClick)="cancelEdit()">Cancel</app-button>
      </div>
    }
  </div>
</app-personalized-dialog>
